export default __webpack_public_path__ + "static/media/brown_13_dirtywhite_silver_sunglasses_tongue_out_tech.9179be14.png";